/* imports */

/* blocks ACF */

/* end blocks ACF */

/* components */
import form from './form';
import hero from './hero';
import initReferencesViewer from './references';


/* call functions */

document.addEventListener('DOMContentLoaded', function () {
  console.log('ok');
  hero();
  form();
  initReferencesViewer();


  const header = document.querySelectorAll('header.wp-block-template-part')[0]; // lub dopasuj selektor

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  });
});
